import { render, staticRenderFns } from "./RequirementTable.vue?vue&type=template&id=e9ffee70"
import script from "./RequirementTable.vue?vue&type=script&lang=js"
export * from "./RequirementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports